<template functional>
    <button 
        class="m-tile-otg"
        type="button"
        @click="listeners.click(props.item)"
    >
        <span class="tile-otg-container">
            <span class="tile-otg-title">
                {{ props.item.name }}
            </span>
            <slot />
        </span>
        <span
            v-if="props.item.files.icon"
            class="tile-otg-logo-wrapper"
        >
            <img :src="props.item.files.icon" >
        </span>
    </button>
</template>

<script>
export default {
    name: 'MTileOtg',
    props: {
        item: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
